import { Injectable, signal } from '@angular/core';
import { SignupSteps } from './signup-step';



@Injectable({ providedIn: 'root' })
export class SignupStepService {
  readonly steps = SignupSteps;
  currentStep = signal<number>(this.steps.signup);
  // currentStep = signal<number>(this.steps.nafath);

  nextStep() {
    const next = this.currentStep() + 1;
    if (next <= Object.keys(this.steps).length) {
      this.currentStep.set(next);
    }
  }

  prevStep() {
    const prev = this.currentStep() - 1;
    if (prev >= 1) {
      this.currentStep.set(prev);
    }
  }

  goToStep(stepKey: keyof typeof SignupSteps) {
    this.currentStep.set(this.steps[stepKey]);
  }

  isStep(stepKey: keyof typeof SignupSteps): boolean {
    return this.currentStep() === this.steps[stepKey];
  }

  getStepKeyByValue(value: number): keyof typeof this.steps | undefined {
    return (Object.keys(this.steps) as Array<keyof typeof this.steps>)
      .find(key => this.steps[key] === value);
  }
  resetSteps() {
    this.currentStep.set(this.steps.signup);
  }
}
